// extracted by mini-css-extract-plugin
module.exports = {"view":"styles_view__19jkS","tabContent":"styles_tabContent__2k8xN"};